module.exports = __webpack_public_path__ + "img/news-default.c7df8f3f.png";